import { PermissionAction } from "./types/PermissionAction";
import { TeamRole } from "./types/TeamRole.enum";
import { TeamRoleDefinition } from "./types/TeamRoleDefinition";

/** Mirrors `TEAM_ROLES` in the API's `team-role.config.ts`: keep the two in step */
export const TEAM_ROLES: TeamRoleDefinition[] = [
  {
    id: TeamRole.OWNER,
    assignable: false,
    defaultActions: [
      PermissionAction.CREATE,
      PermissionAction.READ,
      PermissionAction.UPDATE,
      PermissionAction.DELETE,
    ],
  },
  {
    id: TeamRole.MANAGER,
    assignable: true,
    defaultActions: [
      PermissionAction.CREATE,
      PermissionAction.READ,
      PermissionAction.UPDATE,
    ],
  },
  {
    id: TeamRole.STAFF,
    assignable: true,
    defaultActions: [PermissionAction.READ],
  },
];

export const DEFAULT_INVITE_TEAM_ROLE = TeamRole.STAFF;

export const ASSIGNABLE_TEAM_ROLES = TEAM_ROLES.filter(
  ({ assignable }) => assignable,
);
